import React from "react";
import ReactRoundedImage from "react-rounded-image";
import { useSelector } from "react-redux";
import { Text, Grid, Card, Button, Progress } from "@mantine/core";
import { CDN_URL } from "../../constant";
const DashboardStats = () => {
	const user = useSelector((state) => state.userInformationReducer.users);
	const RegTimeUTC = new Date(user?.createdAt);
	const month = RegTimeUTC.toLocaleString("default", { month: "long" });
	const RegTime = `${RegTimeUTC.getDate()} ${month} ${RegTimeUTC.getFullYear()}`;
	return (
		<>
			<Grid>
				<Grid.Col md={6} lg={6} sx={{ display: "inline-flex" }}>
					<div
						style={{
							margin: "auto 1rem auto 0",
							height: "75px",
						}}
					>
						<ReactRoundedImage
							imageWidth="75"
							imageHeight="75"
							roundedSize="0"
							image={
								user?.userProfile && CDN_URL + user?.userProfile
							}
						/>
					</div>
					<div
						style={{
							height: "fitContent",
							margin: "auto 0",
						}}
					>
						<Text
							weight={700}
							color="white"
							style={{
								fontSize: "1.5rem",
								color: "white",
								fontFamily: "SFPro Display",
							}}
						>
							{`${user?.FirstName} ${user?.LastName}`}
						</Text>
						<Text
							style={{
								fontSize: "1rem",
								fontFamily: "SFPro Display",
								color: "white",
							}}
						>{`Email:  ${user?.AuthValue}`}</Text>
						<Text
							style={{
								fontSize: "1rem",
								fontFamily: "SFPro Display",
								color: "white",
							}}
						>{`User ID:  ${user?.UserId}`}</Text>
						<Text
							style={{
								fontSize: "1rem",
								fontFamily: "SFPro Display",
								color: "white",
							}}
						>{`Registered On: ${RegTime}`}</Text>
					</div>
				</Grid.Col>
				<Grid.Col md={6} lg={3}>
					<Card
						shadow="sm"
						p="xl"
						style={{
							background: "#040F1F",
							border: "1px solid #09254E",
							color: "white",
						}}
					>
						<Text size="sm">Bandwidth</Text>

						<Text weight={500} size="lg">
							Data used
						</Text>
						<Progress radius="xs" value={50} mb={9} />

						<span style={{ float: "left", fontSize: "12px" }}>
							MONTHLY
						</span>
						<span style={{ float: "right", fontSize: "12px" }}>
							1000 MB /2000 MB
						</span>
						<br></br>
					</Card>
				</Grid.Col>
				<Grid.Col md={6} lg={3}>
					<Card
						shadow="sm"
						p="xl"
						style={{
							background: "#040F1F",
							border: "1px solid #09254E",
							color: "white",
						}}
					>
						<Text size="sm">
							<Text size="sm">Need more space & Bandwidth</Text>
						</Text>
						<Text weight={500} size="lg">
							Upgrade to pro
						</Text>
						<Button
							mt={10}
							style={{ width: "10rem", color: "#14B8E1" }}
							variant="outline"
							type="submit"
							component="a"
							target="_blank"
							rel="noopener noreferrer"
							href="https://google.com/"
							disabled
						>
							View All Plans &nbsp; &nbsp;
							<span styles={{ float: "right" }}>&#8594;</span>
						</Button>
					</Card>
				</Grid.Col>
			</Grid>
			<Grid>
				<Grid.Col md={6} lg={3}>
					<Card
						shadow="sm"
						p="xl"
						style={{ background: "#192535", color: "white" }}
					>
						<Text size="sm">
							<Text size="sm">NUMBER OF</Text>
						</Text>
						<Text weight={500} size="lg">
							VIEW
						</Text>
						<Text
							weight={700}
							size="xl"
							style={{ color: "#14B8E1" }}
						>
							140k
						</Text>
					</Card>
				</Grid.Col>
				<Grid.Col md={6} lg={3}>
					{" "}
					<Card
						shadow="sm"
						p="xl"
						style={{ background: "#192535", color: "white" }}
					>
						<Text size="sm">
							<Text size="sm">NUMBER OF</Text>
						</Text>
						<Text weight={500} size="lg">
							VIEWER
						</Text>
						<Text
							weight={700}
							size="xl"
							style={{ color: "#14B8E1" }}
						>
							2k
						</Text>
					</Card>
				</Grid.Col>
				<Grid.Col md={6} lg={3}>
					<Card
						shadow="sm"
						p="xl"
						style={{ background: "#192535", color: "white" }}
					>
						<Text size="sm">
							<Text size="sm">NUMBER OF</Text>
						</Text>
						<Text weight={500} size="lg">
							EXPERIENCES
						</Text>
						<Text
							weight={700}
							size="xl"
							style={{ color: "#14B8E1" }}
						>
							15
						</Text>
					</Card>
				</Grid.Col>
				<Grid.Col md={6} lg={3}>
					<Card
						shadow="sm"
						p="xl"
						style={{ background: "#192535", color: "white" }}
					>
						<Text size="sm">
							<Text size="sm">NUMBER OF</Text>
						</Text>
						<Text weight={500} size="lg">
							SHARES
						</Text>
						<Text
							weight={700}
							size="xl"
							style={{ color: "#14B8E1" }}
						>
							2k
						</Text>
					</Card>
				</Grid.Col>
			</Grid>
		</>
	);
};

export default DashboardStats;
